var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormulaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68572 14V5.27273H8.91868V6.21023H4.74254V9.15909H8.52663V10.0966H4.74254V14H3.68572ZM11.2401 5.27273L13.4901 8.90341H13.5582L15.8082 5.27273H17.0526L14.3082 9.63636L17.0526 14H15.8082L13.5582 10.4375H13.4901L11.2401 14H9.99574L12.8082 9.63636L9.99574 5.27273H11.2401Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormulaIcon);
export default __webpack_public_path__ + "static/media/formula-icon.bd83dfd0116d1b424e9a75051d4bd7b3.svg";
export { ForwardRef as ReactComponent };